<template>
  <div class="addMovie-page" ref="page" @scroll="handlePageScroll">
    <div class="movie-average as-flex flex-vertical main-center cross-center">
      <div class="movie-average-box as-flex">
        <div
          :class="['movie', 'f-3 ','as-flex', 'main-center', 'cross-center ',searchMethod==='movies'?'active':'']"
          @click="changeMovieAverage('movies')"
        >影片</div>
        <div
          :class="['average', 'f-3 ','as-flex', 'main-center', 'cross-center ',searchMethod==='average'?'active':'']"
          @click="changeMovieAverage('average')"
        >均值</div>
      </div>
      <div class="fixed-search-bar as-flex main-center cross-center">
        <div class="f-3 search-btn as-flex main-center cross-center">
          <img src="../../assets/images/search-3x.png" class="search-img">
          <input class="search-placeholder f-2 fc-gray-2" placeholder="搜索影片" v-model="searchInfo">
        </div>
      </div>
    </div>

    <div v-if="searchMethod==='movies'" class="movie-box">
      <div class="filter-box">
        <folderFilterBox
          key="normal"
          ref="filterBox"
          :filterTypesModel="filterTypes"
          :showDetailSearch="true"
          :currentFilterFlag="currentFilter"
          @executeFilter="recieveFilterChange"
        ></folderFilterBox>
      </div>
      <div ref="listContainer" :class="['list-container','f-3']">
        <div ref="scrollContainer" v-if="movieList&&movieList.length>0">
          <template v-for="item in movieList" v-if="item.movie&&item.movie.id">
            <div
              :key="'movie_'+ item.movie.id"
              @click="toggleCurrentChosenMovies({id:item.movie.id,title:item.movie_name})"
              class="movie-box-container"
            >
              <movieBox
                :movieInfo="item"
                type="multi"
                :chosen="currrentChosenMovies.indexOf(item.movie.id)>=0"
              ></movieBox>
            </div>
          </template>
        </div>
        <template v-else>
          <!-- <div
            v-if="noMovieListResult"
            class="no-movie f-2 fc-gray-2 as-flex flex-vertical main-center cross-center"
          >
            <img class="no-movie-img" src="../assets/images/has-no-data-3x.png" alt>
            <p>暂无符合条件的影片</p>
          </div>-->
        </template>
      </div>
    </div>
    <div v-else class="average-box as-flex flex-vertical main-start cross-start f-2">
      <div class="filter-row movie-tags as-flex main-start cross-start">
        <div class="tag-title">标签</div>
        <div class="tag-list as-flex main-start cross-center">
          <template v-for="item in filterTags">
            <span
              @click="item.is_allowed?multiSelectFilter('tags',item):()=>{}"
              :class="[currentFilter.tags.includes(item.id)?'is-filter-active':'',  'f-2', 'list-item', item.is_allowed?'is-allowed':'is-not-allowed','as-flex' ,'flex-horizontal', 'main-center', 'cross-center']"
              :key="item.id"
              :ref="item.value + item.id"
            >{{item.name}}</span>
          </template>
        </div>
      </div>
      <div class="filter-row movie-locations as-flex main-start cross-start">
        <div class="tag-title">地区</div>
        <div class="tag-list as-flex main-start cross-center">
          <template v-for="item in filterDistricts">
            <span
              @click="item.is_allowed?multiSelectFilter('location',item):()=>{}"
              :class="[currentFilter.location.includes(item.id)?'is-filter-active':'',  'f-2', 'list-item',item.is_allowed?'is-allowed':'is-not-allowed', 'as-flex' ,'flex-horizontal', 'main-center', 'cross-center']"
              :key="item.id"
              :ref="item.value + item.id"
            >{{item.name}}</span>
          </template>
        </div>
      </div>
      <div class="filter-row movie-year as-flex main-start cross-start">
        <div class="tag-title">年份</div>
        <div class="tag-list as-flex main-start cross-center">
          <template v-for="item in filterYears">
            <span
              @click="item.is_allowed?multiSelectFilter('year',item):()=>{}"
              :class="[currentFilter.year.includes(item.id)?'is-filter-active':'',  'f-2', 'list-item',item.is_allowed?'is-allowed':'is-not-allowed', 'as-flex' ,'flex-horizontal', 'main-center', 'cross-center']"
              :key="item.id"
              :ref="item.value + item.id"
            >{{item.name}}</span>
          </template>
        </div>
      </div>
    </div>
    <div
      class="multi-bubble bubble-confirm as-flex flex-vertical main-center cross-center f-2"
      @click="changeMultiStatus(true)"
    >
      <template v-if="searchMethod === 'movies'">
        <span>{{currrentChosenMovies.length === 0?'多选':`${currrentChosenMovies.length }部`}}</span>
      </template>
      <template v-else>
        <span>{{averageInfo.id && averageInfo.count > 0?`${averageInfo.count}部`:'多选'}}</span>
      </template>
      <span>对比</span>
    </div>
  </div>
</template>

<script>
import tagApi from "../../api/tagApi.js";
import surveyApi from "../../api/surveyApi.js";
import movie_resultsApi from "../../api/movie_resultsApi.js";
import { clone } from "lodash";
import folderFilterBox from "../common/folderFilterBox";
import movieBox from "../common/movieBox.vue";

export default {
  name: "addCompaireMovies",
  props: {},
  components: {
    folderFilterBox: folderFilterBox,
    movieBox: movieBox
  },
  data() {
    return {
      tagApi: new tagApi(),
      surveyApi: new surveyApi(),
      movie_resultsApi: new movie_resultsApi(),
      isLoadingMovie: false,
      currentAuthorizedStatus: true,
      currentAuthorizedMsg: "",
      pageInfo: {
        page: 1,
        per_page: 10
      },
      //init filter config
      filterTypes: {
        tags: true,
        location: true,
        box: true,
        year: true,
        orderby: true,
        cycle: true
      },
      filterTags: [],
      filterDistricts: [],
      filterYears: [],
      searchInfo: "",
      //method: movies || average
      searchMethod: "movies",
      currentFilter: {
        tags: "",
        location: "",
        box: "",
        year: "",
        orderby: "",
        cycle: ""
      },
      movieList: [],
      currrentChosenMovies: [],
      currentChosenMoviesInfo: [],
      averageInfo: {
        title: "",
        count: undefined,
        id: undefined
      }
    };
  },
  methods: {
    async initFilterConfig() {
      //gei every filter tag`s content by api
      let tags = await this.tagApi.getTypeTags();
      if (tags.code === 200) {
        this.filterTags = tags.data;
      } else {
        this.isLoadingMovie = false;
        throw new Error("获取类型标签错误");
      }
      let location = await this.tagApi.getDistrictTags();
      if (location.code === 200) {
        this.filterDistricts = location.data;
      } else {
        this.isLoadingMovie = false;
        throw new Error("获取地区标签错误");
      }

      let year = await this.tagApi.GetYearTags();
      if (year.code === 200) {
        this.filterYears = year.data;
      } else {
        throw new Error("获取年份标签错误");
      }
    },
    changeMultiStatus(data) {
      this.addCompaireMovies(this.searchMethod);
    },
    changeMovieAverage(flag) {
      this.currentFilter = {
        tags: flag === "movies" ? "" : [],
        location: flag === "movies" ? "" : [],
        box: flag === "movies" ? "" : [],
        year: flag === "movies" ? "" : [],
        orderby: flag === "movies" ? "" : [],
        cycle: flag === "movies" ? "" : []
      };
      this.searchMethod = flag;
    },
    recieveFilterChange(info) {
      if (
        info.orderby === this.currentFilter.orderby &&
        info.year === this.currentFilter.year &&
        info.box === this.currentFilter.box &&
        info.location === this.currentFilter.location &&
        info.cycle === this.currentFilter.cycle &&
        info.tags === this.currentFilter.tags
      ) {
        return;
      }
      this.currentFilter = clone(info);
    },
    toggleCurrentChosenMovies(info = { id: undefined, title: undefined }) {
      if (this.currrentChosenMovies.indexOf(info.id) >= 0) {
        this.currrentChosenMovies.splice(
          this.currrentChosenMovies.indexOf(info.id),
          1
        );
        this.currentChosenMoviesInfo = this.currentChosenMoviesInfo.filter(
          item => {
            return item.id !== info.id;
          }
        );
      } else {
        //电影列表和详情列表 最多保持十个
        if (this.currrentChosenMovies.length === 10) {
          //一次性提示
          if (
            this.$store.getters["onceMessage/getAddCompaireMovieMoreThanTen"]
          ) {
            this.$message({
              message: "最多选择10部影片",
              type: "warning"
            });
            // this.$store.commit("onceMessage/setAddCompaireMovieMoreThanTen", {
            //   status: false
            // });
          }
          return;
        }
        // if (this.currentChosenMoviesInfo.length > 10) {
        //   this.currentChosenMoviesInfo.slice(0, 10);
        // }
        this.currrentChosenMovies.push(info.id);
        this.currentChosenMoviesInfo.unshift(info);
      }
    },
    multiSelectFilter(type, info) {
      if (this.currentFilter[type].includes(info.id)) {
        this.currentFilter[type] = this.currentFilter[type].filter(item => {
          return item !== info.id;
        });
      } else {
        this.currentFilter[type].push(info.id);
      }
    },
    async executeFilter(info = {}, type = "refresh") {
      if (this.isLoadingMovie === true) {
        return;
      }
      this.isLoadingMovie = true;
      //handle with this.currentFilter
      let params = {};
      params.title = this.searchInfo;
      params.sort = info.orderby;
      params.box = info.box;
      params.offset = info.cycle;
      params.year = info.year;
      params.tag_ids = [info.tags, info.location].filter(item => {
        return item !== "";
      });
      params.range_year = info.range_year || [];
      params.range_box = info.range_box || [];
      if (type === "refresh") {
        params.page = 1;
        if (this.$refs.page && this.$refs.page.scrollTo) {
          this.$refs.page.scrollTo(0, 0);
        } else if (this.$refs.page && this.$refs.page.scrollTop) {
          this.$refs.page.scrollTop = 0;
        }
      } else {
        params.page = this.pageInfo.page + 1;
      }
      params.per_page = this.pageInfo.per_page;
      let res = await this.movie_resultsApi.searchMovieResult(params);
      if (res.status === true && res.code === 200) {
        if (type === "refresh") {
          this.pageInfo.page = 1;
          this.movieList = res.data;
        } else {
          //type = loadmore
          if (res.data.length === 0) {
            //没有更多
            this.$message({
              message: "已经到底啦",
              type: "warning"
            });
          }
          this.pageInfo.page += 1;
          this.movieList = this.movieList.concat(res.data);
        }
        this.isLoadingMovie = false;
      } else {
        this.isLoadingMovie = false;
        //没有更多
        this.$message({
          message: "查询影片错误",
          type: "error"
        });
      }
      //call api to filter info
    },
    async handleAverage(to) {
      let tags = to.tags.concat(to.location).filter(item => {
        return item !== "";
      });
      let year = to.year.filter(item => {
        return item !== "";
      });
      let res = await this.tagApi.getMoviesAmountByTags({
        tag_ids: tags,
        year: year
      });
      // if (res.status !== true || res.code !== 200) {
      //   throw new Error("请求影片数量接口错误");
      // }
      switch (res.code) {
        case 200:
          {
            this.currentAuthorizedStatus = true;
          }
          break;
        case 700:
          {
            this.currentAuthorizedStatus = false;
            this.currentAuthorizedMsg = res.msg;
          }
          break;
        default: {
          throw new Error("请求影片数量接口错误");
        }
      }
      this.averageInfo.title = res.data.name || "";
      this.averageInfo.count = res.data.count || 0;
      this.averageInfo.id = res.data.id || undefined;
    },
    addCompaireMovies(flag) {
      if (!this.currentAuthorizedStatus && this.searchMethod === "average") {
        this.$message({
          message: this.currentAuthorizedMsg,
          type: "warning"
        });
        return;
      }
      if (flag === "average") {
        this.currrentChosenMovies = [this.averageInfo.id];
      }
      this.$store.commit("movie/addMovieList", {
        list: this.currrentChosenMovies
      });
      this.$store.commit("movie/updateTotalMovieState");
      this.currrentChosenMovies = [];
      this.$emit("close");
    },
    initPageInfo() {
      this.pageInfo.page = 1;
    },
    handlePageScroll() {
      //触底加载更多
      let scrollTop = this.$refs.page.scrollTop;
      let offsetHeight = this.$refs.page.clientHeight;
      let scrollHeight = this.$refs.page.scrollHeight;
      let minus = offsetHeight + scrollTop;
      if (Math.abs(scrollHeight - minus) < 1) {
        this.pullUploadMore();
      }
    },
    async pullUploadMore() {
      //call api to load more data
      await this.executeFilter(this.currentFilter, "loadmore");
    }
  },
  computed: {},
  watch: {
    searchInfo: function(to, from) {
      //call api to search movie
      this.executeFilter(this.currentFilter);
    },
    currentFilter: {
      handler: async function(to, from) {
        this.initPageInfo();
        let method = this.searchMethod;
        if (method === "average") {
          await this.handleAverage(to);
        } else {
          this.executeFilter(to);
          //call api to  search movies with  this.currentFilter & searchInfo
        }
      },
      deep: true
    },
    isLoadingMovie: function(to, from) {
      // if (to) {
      //   Indicator.open({
      //     text: "数据加载中",
      //     spinnerType: "fading-circle"
      //   });
      // } else {
      //   Indicator.close();
      // }
    }
  },
  async created() {
    await this.initFilterConfig();
    this.executeFilter(this.currentFilter, "loadmore");
  }
};
</script>

<style lang="scss" scoped>
.addMovie-page {
  // position: relative;
  background-color: #fff;
  height: 100%;
  // max-height: 100%;
  width: 100%;
  overflow-y: scroll;
}
.fixed-search-bar {
  width: 100%;
  background-color: #ffffff;
  margin: 10px 0;
  .search-btn {
    position: relative;
    width: 450px;
    height: 40px;
    background-color: #f8f8f8;
    border-radius: 20px;
    .search-img {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 10px;
      width: 15px;
      height: 15px;
      margin-right: 5px;
    }
    .search-placeholder {
      color: #666666;
    }
  }
}
.movie-average {
  // height: 1.04rem;
  width: 100%;
  background-color: #ffffff;
  margin-bottom: 10px;
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 1;
  .movie-average-box {
    width: 200px;
    height: 30px;
    border: 1px solid #4d9ffc;
    color: #4d9ffc;
    .movie {
      width: 50%;
      height: 100%;
    }
    .average {
      width: 50%;
      height: 100%;
    }
    .active {
      background-color: #4d9ffc;
      color: #ffffff;
    }
  }
}
.average-box {
  width: 100%;
  background-color: #ffffff;
  .filter-row {
    width: 100%;
    .tag-title {
      padding: 4px;
      white-space: nowrap;
    }
    .tag-list {
      padding: 4px;
      flex-wrap: wrap;
      .list-item {
        white-space: nowrap;
        margin: 0rem 15px 15px 0;
        height: 30px;
        width: 80px;
        line-height: 30px;
        border: 1px solid #d7d7d7;
        border-radius: 20px;
        &.is-not-allowed {
          border: 1px solid #eeeeee;
          background-color: #eeeeee;
          color: #999999;
        }
      }
      .is-filter-active {
        background-color: #008cd6;
        border: 1px solid rgba(255, 255, 255, 0);
        color: #ffffff;
      }
    }
  }
}
.filter-box {
  width: 100%;
  // position: sticky;
  // position: -webkit-sticky;
  // top: 0;
  z-index: 1;
}
.list-container {
  margin-top: 20px;
  width: 100%;
  padding: 0px;
  .movie-box-container {
    padding: 0 10px;
    background-color: #ffffff;
    width: 100%;
    height: 150px;
    border-bottom: 1px solid #eeeeee;
  }
}
.movie-box-container {
  padding: 0 0.3rem;
  background-color: #ffffff;
  width: 100%;
  height: 2.13rem;
  border-bottom: 0.02rem solid #eeeeee;
}
.multi-bubble {
  position: absolute;
  position: sticky;
  position: -webkit-sticky;
  height: 50px;
  width: 50px;
  border-radius: 25px;
  z-index: 9999;
  background-color: #008cd6;
  box-shadow: 0px 0px 2px 2px #61b6e6;
  bottom: 50px;
  color: #fff;
  cursor: pointer;
  &:hover {
    animation: pulse 2s infinite;
  }
  &.bubble-confirm {
    bottom: 50px;
    left: calc(100% - 100px);
  }
}
@keyframes pulse {
  0% {
    transform: scale(1);
  }
  70% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

input {
  outline: none;
  height: 40px;
  width: 390px;
  color: white;
  border: none;
  // border-radius: 20px;
  // padding: 0.05rem 1rem;
  background-color: #f8f8f8;
}
input::hover {
  outline: none;
}
</style>
